import { createFileRoute } from '@tanstack/react-router';
import { zodValidator } from '@tanstack/zod-adapter';

import { TestSetListPageFilterSchema } from './-zod-schema';

// テストセット 一覧（QA Force グローバルメニュー）。
// URL search のスキーマだけここで定義し、コンポーネントは index.lazy.tsx 側で
// 遅延ロードして bundle 分割する。
export const Route = createFileRoute('/_stacktrace/test-sets/_layout/')({
  validateSearch: zodValidator(TestSetListPageFilterSchema),
});
